import React from 'react';
import { navigate } from "gatsby";

const Hero = ({ text, url }) => {
    const onClick = () => navigate(url)
    return (
        <div className="h-48 bg-green-300 dark:bg-gray-500 rounded-md shadow-lg border">
            <button className="hover:bg-blue-500 h-full w-full" onClick={() => onClick()}>
                <p className="text-xl font-bold sm:text-2xl dark:text-white m-auto">
                    {text}
                </p>
            </button>
        </div>
    )
}

export default Hero